import FinancialDetails from './FinancialDetails'

export default FinancialDetails
